import React from "react";
import "./about.css";
import userProfile from "../../assets/sea-2.webp";

const About = () => {
  const yearsExperience = Math.max(
    1,
    Math.floor(
      (Date.now() - new Date("2020-10-01").getTime()) /
        (1000 * 60 * 60 * 24 * 365)
    )
  );

  return (
    <section id="about" aria-labelledby="about-heading">
      <h5>About</h5>
      <h2 id="about-heading">A bit about me</h2>

      <div className="container about__container reveal">
        <div className="about__visual">
          <div className="about__visual-frame">
            <img
              src={userProfile}
              alt="Kushtrim Shabani"
              width="1000"
              height="1159"
              loading="lazy"
            />
          </div>
        </div>

        <div className="about__content">
          <p className="about__text">
            I got into web development back in 2020 and haven&apos;t looked
            back since. Over {yearsExperience}+ years I&apos;ve worked with
            startups, agencies, and product teams - building everything
            from landing pages to full-scale products.
          </p>

          <p className="about__text">
            Right now I&apos;m at <strong>DCoding Labs</strong>, where I work
            on <strong>PlateSpect</strong> and <strong>DroSpect</strong> -
            two platforms for vehicle monitoring and drone-based
            inspections. I handle both frontend and backend, from React
            interfaces to NestJS services running on GCP.
          </p>

          <p className="about__text">
            When I&apos;m not coding, I like building small games and side
            projects - it keeps things fun and helps me try new tech
            without any pressure.
          </p>

          <div className="about__details pixel-grid">
            <div className="about__detail">
              <span className="about__detail-label pixel-label">Location</span>
              <span className="about__detail-value">Kosovo</span>
            </div>
            <span className="about__detail-sep">&#9670;</span>
            <div className="about__detail">
              <span className="about__detail-label pixel-label">
                Experience
              </span>
              <span className="about__detail-value">{yearsExperience}+ years</span>
            </div>
            <span className="about__detail-sep">&#9670;</span>
            <div className="about__detail">
              <span className="about__detail-label pixel-label">Projects</span>
              <span className="about__detail-value">20+ shipped</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
